import React, { Component } from 'react';
import { getIcon } from '../../../Common/Common';
import { pushCommand, pushGroupCommand, isEmpty, addAnimation, getIsShowVMode, getIsShowVAmount } from '../../../Common/Common';

import Power_On_Off from './Components/Power_On_Off';
import Off_Timer from './Components/Off_Timer';
import VMode from './Components/VMode';
import VAmount from './Components/VAmount';
import Freshup from './Components/Freshup';
import Advanced_Settings from './Components/Advanced_Settings';

import Error_Message from './Components/Error_Message';

export default class HrvOperation extends Component {
	constructor(props) {
		super(props);

		let on_off = 'off';
		if (!isEmpty(this.props.point_info)) {
			if (this.props.point_info.stat != null) on_off = this.props.point_info.stat;
		}

		this.state = {
			on_off: on_off
		}
	}

	handleSendCommand = (command, val) => {
		// Check whether it is a point operation or group operation
		if (this.props.group_id != null) {
			pushGroupCommand(command, val, this.props.group_id);
		} else if (this.props.point_id != null) {
			this.target_id = this.props.point_id;
			pushCommand(command, val, this.props.point_id);
		}
	}

	handleOnOff = () => {
		let val = 'off';
		let elem = document.getElementById('icon_container');

		if (this.state.on_off == 'off') {
			val = 'on';
			addAnimation(elem, 'fadeInLong', () => { }, 2000)
			this.setState({ on_off: 'on' });
		} else {
			addAnimation(elem, 'fadeOutLongFast', () => {
				this.setState({ on_off: 'off' });
			}, 200)
		}
		let command = 'stat';
		this.handleSendCommand(command, val);
	}

	handleChangeVMode = (val) => {
		let command = 'vmode';
		this.handleSendCommand(command, val);
	}

	handleChangeVAmount = (val) => {
		let command = 'vamount';
		this.handleSendCommand(command, val);
	}

	handleToggleFreshup = (val) => {
		let command = 'freshup';
		this.handleSendCommand(command, val);
	}

	handleToggleOffTimer = (val) => {
		let command = 'off_timer';
		this.handleSendCommand(command, val);
	}

	render() {
		let icon = null;
		if (this.props.point_id != null && !isEmpty(this.props.point_info)) icon = getIcon(this.props.point_info.icon, this.props.point_info.stat);
		else if (this.props.group_id != null && !isEmpty(this.props.group_info)) icon = getIcon(this.props.group_info.icon);
		let icon_width = 50;

		let op_button_cell_style = {
			width: 80,
			height: 80,
			margin: 5,
			padding: 10,
			backgroundColor: 'white',
			borderRadius: 20,
			boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
			fontSize: 11,
		}

		let power_icon_width = 150;

		let background_gradient = 'radial-gradient(#8dff95 5%, #daffda 50%, #fffcfc 70%)';
		let icon_container_style = {
			width: icon_width + 30,
			height: icon_width + 30,
			position: 'absolute',
			top: -(power_icon_width + 10),
			left: 20,
			backgroundImage: background_gradient,
			display: this.state.on_off == 'on' ? 'block' : 'none',
		}

		let is_show_vmode = false;
		let is_show_freshup = true;
		let is_show_vamount = false;
		let is_show_error_message = false;
		let error_message = '';

		if (this.props.point_id != null && !isEmpty(this.props.point_info)) {
			is_show_vmode = getIsShowVMode(this.props.point_info);
			is_show_vamount = getIsShowVAmount(this.props.point_info);
			is_show_freshup = this.props.point_info.vamount_cap.F;

			if (this.props.point_info.error != null) {
				//check if device has device error
				let device_error = this.props.point_info.error;
				for (var key in device_error) {
					if (device_error[key]) {
						error_message = key;
						is_show_error_message = true;
					}
				}
			}
		} else if (this.props.group_info != null) {
			// loop through group_info.mp to check operation capabilities of all Ac points
			for (let point_id of this.props.group_info.mp) {
				let point_info = window.app.state.point_list[point_id];
				if (!isEmpty(point_info)) {
					if (point_info.type == 'Hrv') {
						if (point_info.vmode_cap != null) {
							if (point_info.vmode_cap.A || point_info.vmode_cap.HX || point_info.vmode_cap.S) {
								is_show_vmode = true;
							}
						}

						if (point_info.vamount_cap != null) {
							if (point_info.vamount_cap.A || point_info.vamount_cap.H || point_info.vamount_cap.L) {
								is_show_vamount =  true;
							}
						}

						if (point_info.vamount_cap != null) {
							if (point_info.vamount_cap.F) is_show_freshup = true;
						}

					}
				}
			}
		}

		let available_functions = this.props.receiver.active_controller.available_functions;
		let is_show_advanced_settings = false;
		
		if (this.props.group_id == null && !isEmpty(this.props.point_info)) {
			if (this.props.point_info.rc_proh_cap && available_functions.rc_proh) {
				is_show_advanced_settings = true;
			}
		}

		return (
			<div id='hrv_operation' style={{ height: this.props.height - 70, overflow: 'auto' }}>
				{this.props.group_id == null ?
					<div style={{ cursor: 'pointer', }} onClick={this.handleOnOff}>
						<div style={{ verticalAlign: 'top', marginTop: 20 }}>
							<Power_On_Off
								style={{}}
								img_width={power_icon_width}
								receiver={this.props.receiver}
								point_info={this.props.point_info}
								on_off={this.state.on_off}
							/>
						</div>
						<div style={{ position: 'relative' }}>
							<div id='icon_container' style={icon_container_style}></div>
							<img id={'device_icon'} src={icon} alt='icon' style={{ width: icon_width, opacity: 0.6, position: 'absolute', top: -(power_icon_width - 5), left: 35, }} />
						</div>
					</div> : null}
				{is_show_error_message ?
					<div id='error_message'>
						<Error_Message
							deviceErrorMessage={error_message}
						/>
					</div> : null}

				<div id='op_buttons' style={{ marginBottom: 10, marginTop: 80 }}>
					<div style={{ display: is_show_vmode ? 'inline-block' : 'none', verticalAlign: 'top' }}>
						<VMode
							style={op_button_cell_style}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleChangeVMode={this.handleChangeVMode}
						/>
					</div>
					<div style={{ display: is_show_vamount ? 'inline-block' : 'none', verticalAlign: 'top' }}>
						<VAmount
							style={op_button_cell_style}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleChangeVAmount={this.handleChangeVAmount}
						/>
					</div>
					<div style={{ display: is_show_freshup ? 'inline-block' : 'none', verticalAlign: 'top' }}>
						<Freshup
							style={op_button_cell_style}
							receiver={this.props.receiver}
							point_info={this.props.point_info}
							handleToggleFreshup={this.handleToggleFreshup}
						/>
					</div>
					{/* If group operation, hide component */}
					{this.props.group_id == null ?
						<div style={{ display: this.props.receiver.active_controller.user_class == 'Admin' ? 'inline-block' : 'none', verticalAlign: 'top' }}>
							<Off_Timer
								style={op_button_cell_style}
								receiver={this.props.receiver}
								point_info={this.props.point_info}
								handleToggleOffTimer={this.handleToggleOffTimer}
							/>
						</div> : null}
				</div>
				{is_show_advanced_settings ?
					<Advanced_Settings
						point_id={this.props.point_id}
						point_info={this.props.point_info}
						receiver={this.props.receiver}
						width={this.props.width}
						height={this.props.height}
						group_info={this.props.group_info}
						group_id={this.props.group_id}
						type={'Hrv'}
						colours={this.props.colours}
					/> : null}

			</div>
		)
	}
}